<template>
    <div>
        <header class="main-header">
            <div>
                <a href="/">
                    <img alt="Logo" src="../assets/logo.png">
                </a>
                <nav>
                    <router-link to="/home">网站首页</router-link>
                    <router-link to="/about">公司介绍</router-link>
                    <router-link to="/honor">荣誉证书</router-link>
                    <router-link to="/news">新闻中心</router-link>
                    <router-link to="/announcement">通知公告</router-link>
                    <router-link to="/product">产品介绍</router-link>
                    <router-link to="/social">社会责任</router-link>
                    <router-link to="/partner">合作伙伴</router-link>
                    <router-link to="/recruitment">人才招聘</router-link>
                    <router-link to="/contact">联系我们</router-link>
                </nav>
            </div>
        </header>
        <slot />
        <footer class="main-footer">
            <div>
                <nav v-if="!hideMenu">
                    <router-link to="/home"><span>网站首页</span></router-link>
                    <router-link to="/about">
                        <div class="icon" style="background: #fd7a49"><img src="../assets/ico1.png"></div>
                        <span>公司介绍</span>
                    </router-link>
                    <router-link to="/honor">
                        <div class="icon" style="background: #fe9700"><img src="../assets/ico2.png"></div>
                        <span>荣誉证书</span>
                    </router-link>
                    <router-link to="/news">
                        <div class="icon" style="background: #f26765"><img src="../assets/ico3.png"></div>
                        <span>新闻中心</span>
                    </router-link>
                    <router-link to="/announcement">
                        <div class="icon" style="background: #009688"><img src="../assets/ico3.png"></div>
                        <span>通知公告</span>
                    </router-link>
                    <router-link to="/product">
                        <div class="icon" style="background: #19cf8a"><img src="../assets/ico4.png"></div>
                        <span>产品介绍</span>
                    </router-link>
                    <router-link to="/social">
                        <div class="icon" style="background: #7f2d00"><img src="../assets/ico5.png"></div>
                        <span>社会责任</span>
                    </router-link>
                    <router-link to="/partner">
                        <div class="icon" style="background: #4493f7"><img src="../assets/ico6.png"></div>
                        <span>合作伙伴</span>
                    </router-link>
                    <router-link to="/recruitment">
                        <div class="icon" style="background: #6f68df"><img src="../assets/ico7.png"></div>
                        <span>人才招聘</span>
                    </router-link>
                    <router-link to="/contact">
                        <div class="icon" style="background: #7fd02b"><img src="../assets/ico8.png"></div>
                        <span>联系我们</span>
                    </router-link>
                </nav>
                <p>电话：0512-68258244、68249344、68085312</p>
                <p>传真：0512-68259892</p>
                <p>信息产业部备案：苏ICP备10003553号</p>
                <p>Copyright 2019 www.shengjia-resin.com All rights reserved.</p>
            </div>
        </footer>
    </div>
</template>

<script>
    import {
        VueAgile
    } from 'vue-agile'
    export default {
        name: 'MainFrame',
        components: {
            agile: VueAgile
        },
        computed: {
            hideMenu() {
                if ((this.$route.path !== '/') && (this.$route.path !== '/home') && (window.innerWidth < 480)) {
                    return true
                }
            }
        }
    }
</script>

<style lang="less">
    .main-header,
    .main-footer {
        background-color: #f4f4f4;

        >div {
            max-width: 1024px;
            margin: 0 auto;
        }
    }

    .main-header>div {
        display: flex;
        justify-content: space-between;
        align-items: center;

        nav {
            flex-grow: 1;
            display: flex;
            justify-content: flex-end;

            a {
                display: block;
                position: relative;
                padding: 32px 16px;
                font-size: 14px;
                color: #000;
                text-decoration: none;
                transition: .5s;
                white-space: nowrap;

                &::before {
                    content: "";
                    position: absolute;
                    left: 24px;
                    width: 0;
                    bottom: 24px;
                    height: 3px;
                    background: #e4b248;
                    transition: width .5s;
                }

                &.router-link-active,
                &:hover {
                    color: #fff;
                    background-color: #3f4f96;

                    &::before {
                        width: calc(100% - 48px);
                    }
                }
            }
        }
    }

    .main-footer>div {
        text-align: center;
        padding: 32px 0;
        font-size: 12px;

        nav {
            margin-bottom: 32px;

            a {
                text-decoration: none;
                margin: 0 16px;
                color: #000;

                .icon {
                    display: none;
                }
            }
        }

        p {
            color: #666;
        }
    }
</style>